<template>

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="left" :show-message="false">
    <div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title">담당자 정보 등록</h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body">

        <el-form-item label="담당자 이름" prop="damdangName">
            <el-input v-model="ruleForm.damdangName"></el-input>
        </el-form-item>
        <hr/>
        <el-form-item label="이메일" >
            <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <hr/>
        <el-form-item label="연락처" >
            <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>

        <!-- <hr v-if="mode === 'update'" />

        <el-form-item v-if="mode === 'update'" label="사용 여부" >
            <el-radio-group v-model="ruleForm.deleteYn">
                <el-radio label="N">사용</el-radio>
                <el-radio label="Y">미 사용</el-radio>
            </el-radio-group>
        </el-form-item> -->

      </div>
      <div class="modal-footer">
        <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">저 장</el-button>
                <el-button @click="$emit('dismiss')">닫 기</el-button>
            </el-form-item>

<!-- 
        <button type="button" class="btn btn-secondary" @click="hideAll" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" @click="other">Save changes</button> -->


      </div>
    </div>
    </el-form>

</template>

<script>
import { mapState } from 'vuex'

export default {
    created() {
        if(this.mode == 'update') {
          this.ruleForm = Object.assign({},this.ruleForm, this.data)
        }
    },
    props: {
        data: {
          type: Object
        },
        mode: {
          type: String
        }
    },
    data() {
      return {
        ruleForm: {
          damdangName: '',
          email: '',
          phone: '',
          deleteYn: 'N'
        },
        rules: {
          damdangName: [
            { required: true, message: ' ', trigger: 'blur' },
          ],
        }
      };
    },    
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$emit('close', this.ruleForm)
                // this.$emit('submit');
            } else {
                alert('필수 항목들을 빠짐없이 입력해 주세요')
                return false;
            }
            });
        },
    },

}
</script>